import React from 'react';

import SignupTemplate from '../components/common/template/SignupTemplate';
import { useSignUp } from '../Hooks/useAuth';

const SignUpPage = () => {
  const {
    state,
    inputRef,
    onChangeValue,
    onClickSignupButton,
    isLoading,
    isValidateTrue,
    allowMarketing,
    allowMarketingCheck,
  } = useSignUp();

  return (
    <SignupTemplate
      state={state}
      inputRef={inputRef}
      onChangeValue={onChangeValue}
      onSignup={onClickSignupButton}
      isLoading={isLoading}
      isValidateTrue={isValidateTrue}
      allowMarketing={allowMarketing}
      allowMarketingCheck={allowMarketingCheck}
    />
  );
};

export default SignUpPage;
